module.exports = __webpack_public_path__ + "static/media/tasks.14d402d0.jpg";